module.exports = __webpack_public_path__ + "static/media/sound_pizza.238b5e4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/sound_pizza.wav
// module id = XdOC
// module chunks = 1